export default __webpack_public_path__ + "static/media/assign-interview-icon.60203e64.svg";